import { Injectable } from "@angular/core";
import { ApiService } from "./api.service";
import { tap } from "rxjs";
import { ReproEnumInitializationQueryResponse } from "../autogenerated/model.autogenerated";

@Injectable({
  providedIn: 'root'
})
export class EnumsService {

  private _enums: ReproEnumInitializationQueryResponse | null = null;

  public get enums() { return this._enums; }

  constructor(private readonly _api: ApiService) {

  }

  public initialize() {
    return this._api.Enum_List()
      .pipe(
        tap(x => this._enums = x)        
      )
  }
}
